import { API_STATES } from '@/helpers'

const state = {
  scheduledTasksGetState    : API_STATES.NOT_REQUESTED,
  scheduledTasksGetError    : null,
  scheduledTasks            : [],
  taskAssignmentUpdateState : API_STATES.NOT_REQUESTED,
  taskAssignmentUpdateError : null,
  taskAssignmentUpdating    : []
}

export default state